'use strict';

Object.defineProperty(exports, "__esModule", { value: true });
exports.getFeatureLocation = exports.getFeatureEnabled = exports.getFeatureValueV2 = exports.FeatureLocationV2 = exports.FeatureValueV2 = exports.FeatureEnabledV2 = void 0;
var tslib_1 = require("tslib");
var vue_class_component_1 = require("vue-class-component");
var util_1 = require("../../util");
var magic_messages_1 = require("@gig/magic-messages");
var magic_sdk_1 = require("@gig/magic-sdk");
/**
 * Makes a helper decorator for getting feature values in components quickly.
 * @param valueGetter Gets the value from the feature service based on slug and default value.
 */
var makeFeatureDecorator = function (valueGetter) {
    return function (_a) {
        var slug = _a.slug, defaultValue = _a.default;
        return vue_class_component_1.createDecorator(function (options, key) {
            var subscriptions = [];
            var isDefaultFunction = typeof defaultValue === 'function';
            var getDefault = function (vm) {
                if (isDefaultFunction) {
                    return defaultValue.call(vm);
                }
                return defaultValue;
            };
            options.created = util_1.hookFunction(options.created, function () {
                var updateValue = function () {
                    return tslib_1.__awaiter(this, void 0, void 0, function () {
                        var _a, _b;
                        return tslib_1.__generator(this, function (_c) {
                            switch (_c.label) {
                                case 0:
                                    _a = this.$data;
                                    _b = key;
                                    return [4 /*yield*/, valueGetter(slug, getDefault(this))];
                                case 1:
                                    _a[_b] = _c.sent();
                                    return [2 /*return*/];
                            }
                        });
                    });
                }.bind(this);
                updateValue();
                // set initial value to default or disabled
                // update value once features are available or when they change
                if (isDefaultFunction) {
                    // Watch the default function return value, so we can update if the value changes.
                    subscriptions.push(this.$watch(function () {
                        return getDefault(this);
                    }, updateValue));
                }
                subscriptions.push(window.eventBus.subscribe(magic_messages_1.LANGUAGE_UPDATED, function () {
                    return updateValue();
                }).unsubscribe);
                subscriptions.push(magic_sdk_1.magic.events.sessionCreated(updateValue).unsub);
                subscriptions.push(magic_sdk_1.magic.events.sessionDestroyed(updateValue).unsub);
                subscriptions.push(magic_sdk_1.magic.events.userUpdated(updateValue).unsub);
            });
            options.beforeDestroy = util_1.hookFunction(options.beforeDestroy, function () {
                subscriptions.forEach(function (unsub) {
                    unsub();
                });
            });
        });
    };
};
exports.FeatureEnabledV2 = makeFeatureDecorator(function (slug) { return tslib_1.__awaiter(void 0, void 0, void 0, function () {
    return tslib_1.__generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, getFeatureEnabled(slug)];
            case 1: return [2 /*return*/, _a.sent()];
        }
    });
}); });
exports.FeatureValueV2 = makeFeatureDecorator(function (slug, defaultValue) { return tslib_1.__awaiter(void 0, void 0, void 0, function () {
    return tslib_1.__generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, getFeatureValueV2(slug, defaultValue)];
            case 1: return [2 /*return*/, _a.sent()];
        }
    });
}); });
exports.FeatureLocationV2 = makeFeatureDecorator(function (slug, defaultValue) { return tslib_1.__awaiter(void 0, void 0, void 0, function () {
    var featureSetting;
    return tslib_1.__generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, queryFeatureValue(slug, defaultValue)];
            case 1:
                featureSetting = _a.sent();
                if (!featureSetting || !featureSetting.isApplicable) {
                    return [2 /*return*/, []];
                }
                return [2 /*return*/, featureSetting.location];
        }
    });
}); });
function queryFeatureValue(slug, defaultValue) {
    return window.queryBus.query(magic_messages_1.FEATURE_QUERY_VALUE, { slug: slug, defaultValue: defaultValue });
}
function getFeatureValueV2(slug, defaultValue) {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        var featureSetting;
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, queryFeatureValue(slug, defaultValue)];
                case 1:
                    featureSetting = _a.sent();
                    if (!featureSetting || !featureSetting.isApplicable) {
                        return [2 /*return*/, defaultValue];
                    }
                    return [2 /*return*/, featureSetting.value];
            }
        });
    });
}
exports.getFeatureValueV2 = getFeatureValueV2;
function getFeatureEnabled(slug) {
    var _a;
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        return tslib_1.__generator(this, function (_b) {
            switch (_b.label) {
                case 0: return [4 /*yield*/, window.queryBus.query(magic_messages_1.FEATURE_QUERY_ENABLED, slug)];
                case 1: return [2 /*return*/, ((_a = (_b.sent())) !== null && _a !== void 0 ? _a : false)];
            }
        });
    });
}
exports.getFeatureEnabled = getFeatureEnabled;
function getFeatureLocation(slug, defaultValue) {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        var featureSetting;
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, queryFeatureValue(slug, defaultValue)];
                case 1:
                    featureSetting = _a.sent();
                    if (!featureSetting || !featureSetting.isApplicable) {
                        return [2 /*return*/, defaultValue];
                    }
                    return [2 /*return*/, featureSetting.location];
            }
        });
    });
}
exports.getFeatureLocation = getFeatureLocation;
